var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcHandCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0278 11.4775C13.1973 11.4775 15.7666 8.9082 15.7666 5.73877C15.7666 2.56933 13.1973 0 10.0278 0C6.8584 0 4.28906 2.56933 4.28906 5.73877C4.28906 8.9082 6.8584 11.4775 10.0278 11.4775ZM8.46101 2.75774C8.07049 2.36721 7.43732 2.36721 7.0468 2.75774C6.65628 3.14826 6.65628 3.78143 7.0468 4.17195L8.61508 5.74023L7.04875 7.30657C6.65823 7.69709 6.65823 8.33025 7.04875 8.72078C7.43928 9.1113 8.07244 9.1113 8.46297 8.72078L10.0293 7.15445L11.5956 8.72078C11.9862 9.1113 12.6193 9.1113 13.0098 8.72078C13.4004 8.33025 13.4004 7.69709 13.0098 7.30657L11.4435 5.74023L13.0118 4.17195C13.4023 3.78143 13.4023 3.14826 13.0118 2.75774C12.6213 2.36721 11.9881 2.36721 11.5976 2.75774L10.0293 4.32602L8.46101 2.75774Z",
    fill: "#D81717"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.618 19.1835H8.12068C7.83135 18.9482 6.49998 16.1402 5.87046 14.7656C5.75438 14.4736 5.64211 13.8196 6.12161 13.5393C6.60111 13.2589 6.95129 13.4778 7.06644 13.6223C7.3279 13.9631 7.92505 14.7204 8.22199 15.023C8.51893 15.3255 8.60846 14.9775 8.61611 14.7656V8.62186C8.61936 8.24531 8.8011 7.49219 9.50213 7.49219C10.2032 7.49219 10.4498 8.04373 10.4855 8.3195L10.6312 11.9339C10.6467 11.4956 10.8351 10.9188 11.5176 10.9188C12.2731 10.9188 12.5047 11.6742 12.5361 12.1482C12.5365 11.6773 12.698 10.926 13.3675 10.9188C14.0997 10.9111 14.4321 11.8178 14.5067 12.2722C14.5197 11.9997 14.6897 11.4547 15.2661 11.4547C15.8425 11.4547 16.0054 11.9085 16.0147 12.1355C16.0844 12.9892 16.2236 14.8462 16.2236 15.4444C16.2236 16.0425 16.1723 16.4635 16.1467 16.5992L15.618 19.1835Z",
    fill: "#FFD0B5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.48828,
    y: 19.0054,
    width: 8.6263,
    height: 2.99418,
    rx: 0.5,
    fill: "#435869"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHandCancel);
export default __webpack_public_path__ + "static/media/ic-hand-cancel.9b2f8ab13684655067c9b5b45dc1e2eb.svg";
export { ForwardRef as ReactComponent };